export default __webpack_public_path__ + "static/media/snowboarding.a78d4b0a.jpg";